import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { DeviceDetectorService } from 'ngx-device-detector';
import { combineLatest, fromEvent, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { AppState } from 'src/app/reducers';
import { AccesoEmail, AccesoEmailMarkable } from 'src/common/acceso';
import { GtagEvent } from 'src/common/gtagEvent';
import { EmailAccesoRequested, EmailToggleMarkedRequested } from '../store/email/email.actions';
import { emailDelegados, emailPersonal } from '../store/email/email.selectors';

@Component({
	selector: 'email',
	templateUrl: './email.component.html',
	styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit, AfterViewInit {

	readonly GTAG_CATEGORY: string = 'correo-electronico';

	filteredPersonal$: Observable<AccesoEmail>;
	filteredDelegados$: Observable<AccesoEmailMarkable[]>;

	@ViewChild( "appFilter", { static: true } )
	appFilter: ElementRef;


	constructor( private store: Store<AppState>, private deviceDetectorService: DeviceDetectorService, private gtag: GtagEvent ) {
	}

	ngOnInit() {
		let fromFilter$: Observable<string> = fromEvent<any>( this.appFilter.nativeElement, 'input' )
			.pipe(
				map( event => this.normalize( event.target.value ) ),
				debounceTime( 100 ),
				distinctUntilChanged(),
				startWith( "" )
			);

		let personal$: Observable<AccesoEmail> = this.store.select( emailPersonal )
			.pipe(
				map( acceso => {
					return acceso? { ...acceso, emailAbreviadoNormalized: this.normalize( acceso.emailAbreviado ) }: acceso;
				})
			);

		let allDelegados$: Observable<AccesoEmailMarkable[]> = this.store.select( emailDelegados )
			.pipe(
				map( accesos => {
					if( accesos && accesos.length > 0 ) {
						accesos = accesos.map( email => {
							return { ...email, emailAbreviadoNormalized: this.normalize( email.emailAbreviado ) };
						})
					}
					return accesos;
				})
			);

		this.filteredPersonal$ = combineLatest( [ personal$, fromFilter$ ] )
			.pipe(
				map( ([ acceso, filterText ] ) =>
					filterText && filterText != ""? ( acceso.emailAbreviadoNormalized.indexOf( filterText ) >= 0? acceso: null ): acceso
				)
			);

		this.filteredDelegados$ = combineLatest( [ allDelegados$, fromFilter$ ] )
			.pipe(
				map( ([ accesos, filterText ] ) =>
					filterText && filterText != ""? accesos.filter( acceso => acceso.emailAbreviadoNormalized.indexOf( filterText ) >= 0 ): accesos
				)
			);
	}

	ngAfterViewInit(): void {
		this.appFilter.nativeElement.focus();
	}

	private normalize( text: string ): string {
		return text? text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(): text;
	}

	private onToggleMark( acceso: AccesoEmailMarkable ) {
		this.store.dispatch( new EmailToggleMarkedRequested( acceso ) );
	}

	private openEmailPersonal( acceso: AccesoEmailMarkable ) {
		if( this.deviceDetectorService.isDesktop() ) {
			this.gtag.emit( 'abrir-cuenta-personal', this.GTAG_CATEGORY, acceso.emailAbreviado );
			this.store.dispatch( new EmailAccesoRequested( { emailCompleto: acceso.emailCompleto } ) );
		}
	}

	private openEmailDelegado( acceso: AccesoEmailMarkable ) {
		if( this.deviceDetectorService.isDesktop() ) {
			this.gtag.emit( 'abrir-cuenta-delegada', this.GTAG_CATEGORY, acceso.emailAbreviado );
			this.store.dispatch( new EmailAccesoRequested( { emailCompleto: acceso.emailCompleto } ) );
		}
	}

	getEmailStyle() {
		return this.deviceDetectorService.isDesktop()? null: { 'filter': 'grayscale( 100% )', 'opacity': '.5' };
	}

}